import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useAppContext } from '../../contexts/AppContext';
import { useMemo, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { buildSoilingRiskOptions } from '../../utils/chartOptions/soilingRisk';

type Props = {
  data: { scores?: { rain?: number | null; deposition?: number | null } };
  name: string;
};

const SoilingRisk = ({ data, name }: Props) => {
  const { isDarkMode } = useAppContext();
  const chartComponent = useRef(null);
  const scores = data?.scores;
  const chartOptions = useMemo(
    () =>
      scores && Object.prototype.hasOwnProperty.call(scores, 'deposition') && Object.prototype.hasOwnProperty.call(scores, 'rain')
        ? buildSoilingRiskOptions(scores, name)
        : null,
    [data],
  );

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        <>
          <Box display="flex" alignItems="center">
            <Typography variant="h5" color="text.primary" sx={{ mt: 0 }}>
              Soiling Risk
            </Typography>
            <ChartHelpTooltip chartType="soilingRisk" />
          </Box>
          {chartOptions && (
            <HighchartsReact
              ref={chartComponent}
              containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
              highcharts={Highcharts}
              options={chartOptions}
            />
          )}
        </>
      </Box>
    </>
  );
};

export default SoilingRisk;
